import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { MatCheckboxChange, MatDialog } from "@angular/material";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NavigationEnd, Router } from "@angular/router";
import { MediaMatcher } from "@angular/cdk/layout";
import * as moment from "moment";
import { MatPaginator, MatTableDataSource } from "@angular/material";
import { Globals } from "../../globals";
import { ToastContainerDirective, ToastrService } from "ngx-toastr";
import { FinanciamientoApiService } from "../../services/financiamiento-reusable.service";
import { e, injectElementRef } from "@angular/core/src/render3";

@Component({
  selector: "app-financiamiento-deuda",
  templateUrl: "./financiamiento-deuda.component.html",
  styleUrls: ["./financiamiento-deuda.component.scss"],
})
export class FinanciamientoDeudaComponent implements OnInit {
  @ViewChild("scrollMe") private myScrollContainer: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @BlockUI() blockUI: NgBlockUI;

  @ViewChild(ToastContainerDirective)
  toastContainer: ToastContainerDirective;

  displayedColumns: string[] = ["fecha", "importe", "seleccionar"];
  displayedColumnsCronograma: string[] = [
    "cuota",
    "fecha",
    "importe",
    "incentivo",
  ];
  dataSourceCronograma: any;
  dataSource: any;

  form: FormGroup;
  flagBoton: boolean = true;
  toggle: boolean = true;
  width = "70%";
  showSuministro = true;
  navigationSubscription;
  mobileQuery: MediaQueryList;
  nro_sumininstro: any;
  nombres: string = "";
  apellidos: string = "";
  tipo_documento: string = "";
  nro_documento: string = "";
  tip_doc: string = "";

  emailSolicitante: string = "";
  tipoSolicitante: string = "";
  parentesco: string;
  telefono: string;
  celular: string;
  codigoOficina: string;
  secuenciaSuministro: string;
  docAdjuntos: any[] = [];

  documents: any[] = [];
  bandejaId: any;

  meses_adeudados: any[] = [];
  meses_seleccionados_map: Map<number, any> = new Map<number, any>();
  importe_financiar: number = 0;
  cronograma_cuotas: any[] = [];
  param_cuota: any[] = [];
  esMontoFueraRango: Boolean = true;
  monto_menor = 9999999;

  cuota_min: number = 0;
  cuota_max: number = 0;
  num_cuotas: number[] = [];
  cuota_inicial_save: number = 0;
  multifamiliar: boolean = false;
  declaro: boolean = false;
  cronogramas_visible: boolean = false;
  finalizado: boolean = false;

  sec_nis: number = 0;
  dni: string = "";
  calc: any = {
    ind_fact_online: "",
    tasa_int: 0,
    imp_multas: 0,
    imp_recargos: 0,
  };

  recibos_pdf: any = {
    numero: "",
    deuda: 0,
    f_fact: "",
    simbolo_var: "",
    simf_vcto_prox_facbolo_var: "",
  };

  "recibos_pdf1": any = {
        numero: "0.66777192 - 13/09/2016",
        deuda: 19.33,
        f_fact: "2016-09-13T00:00:00",
        simbolo_var: "6677719002",
        f_vcto_prox_fac: "2999-12-31T00:00:00"
    };

    "recibos_pdf2": any = {
        numero: "0.66777192 - 12/10/2016",
        deuda: 19.33,
        f_fact: "2016-10-12T00:00:00",
        simbolo_var: "6677719003",
        f_vcto_prox_fac: "2999-12-31T00:00:00"
    };

  responsable: any = {
    nombre: "",
    tipdoc: "",
    numdoc: "",
    mail: "",
  };
  listArchivosAdjuntos : any = [];
  listArchivosAdjuntos1 : any = [
		{
			"idBandeja": 48,
			"tipoDocArchivo": "DW001",
			"nombreArchivo": "Documento_Identidad.jpg",
			"estadoDocumento": "A",
			"motivoRechazo": "prueba"
		},
		{
	        "idBandeja": 48,
	        "tipoDocArchivo": "DW002",
	        "nombreArchivo": "Recibo-Sedapal.jpg",
	        "estadoDocumento": "A",
	        "motivoRechazo": "prueba"
	      },
    ];


  sumcon: any = {
    sec_cta: 0,
    cod_unicom: 0,
    nombre: "",
    ape1: "",
    ape2: "",
    sec_nis: 0,
    doc_id: 0,
    tip_doc: "",
    tip_sol: "",
    mail: "",
    num_cel: 0,
    sum_dir1: "",
    sum_dir2: "",
    cli_dir: "",
    tip_doc_des: "",
    ofi_dir: "",
    ofi_dis: "",
  };

  grabarcuota_response: any = {
    error: false,
    msgerror: "OK",
    num_acu: 1,
    secuencial: "4111202104628",
    recibos_pdf: [
      {
        numero: "0.28007971 - 09/08/2",
        deuda: 1288.4,
        f_fact: "2021-08-09T00:00:00",
        simbolo_var: "2800797278",
        f_vcto_prox_fac: "2999-12-31T00:00:00",
      },
    ],
  };

  secuencial: string = "";
  num_acu: number;

  tamn_old: string = "";

  private _mobileQueryListener: () => void;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public changeDetectorRef: ChangeDetectorRef,
    public media: MediaMatcher,
    private globals: Globals,
    private toastr: ToastrService,
    private financiamientoService: FinanciamientoApiService
  ) {

    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd && this.showSuministro === false) {
        this.showSuministro = true;
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {
    this.toastr.overlayContainer = this.toastContainer;
    this.initForm();

    let finacDeuda: any = JSON.parse(sessionStorage.getItem("finacDeuda"));
    console.log("finacDeuda : ", finacDeuda);

    if (finacDeuda === null || finacDeuda === undefined) {
      this.finalizado = true;
      this.toastr.error("No se encontro los datos del solicitante", "Error", {
        closeButton: true,
      });
      return;
    }

    this.nro_sumininstro = finacDeuda.suministro;
    this.dni = finacDeuda.numeroDocumento;
    this.tip_doc = finacDeuda.tipoDocumento;
    this.nombres = finacDeuda.nombres;
    this.apellidos = finacDeuda.apellidos;
    this.parentesco = finacDeuda.parentesco;
    this.telefono = finacDeuda.telefono;
    this.celular = finacDeuda.celular;
    this.emailSolicitante = finacDeuda.correo;
    this.tipoSolicitante = finacDeuda.tipoSolicitante;
    this.codigoOficina = finacDeuda.codigoOficina;
    this.secuenciaSuministro = finacDeuda.secuenciaSuministro;
    this.listArchivosAdjuntos = finacDeuda.docAdjuntos;
    //this.documents = finacDeuda.documents;
    if (finacDeuda.bandejaId === null || finacDeuda.bandejaId === undefined) {
      this.bandejaId = 0;
    } else {
      this.bandejaId = finacDeuda.bandejaId;
    }
    this.loadMesesAdeudados();
  }
  onChangeCheckBox(ob: MatCheckboxChange) {
    console.log("checked: " + ob.checked);
    if (ob.checked) {
      this.flagBoton = false;
      this.toggle = false;
    }
    else {
      this.flagBoton = true;
      this.toggle = true;
    }
 }
  loadMesesAdeudados() {
    let request: any = {
      nis_rad: this.nro_sumininstro,
      dni: this.dni,
      tip_doc: this.tip_doc,
    };
    console.log("API consulta REQUEST : ", request);
    this.financiamientoService
      .getMesesAdeudados(request)
      .toPromise()
      .then((response: any) => {
        console.log("API consulta RESPONSE : ", response);
        if (response.error == true) {
          if (response.tipo == 'v') {
            this.toastr.error(response.msgerror, "Error", {
              closeButton: true,});
          }
        else {
            this.toastr.error("No se ha podido consultar la información para el financiamiento. Inténtelo nuevamente.", "Error", {
              closeButton: true,});
        }
        return;
      }
        this.nombres = response.sumcon.nombre;
        this.apellidos = response.sumcon.ape1 + " " + response.sumcon.ape2;
        this.tipo_documento = response.sumcon.tip_doc_des;
        this.tip_doc = response.sumcon.tip_doc;
        this.nro_documento = response.sumcon.doc_id;
        this.sec_nis = response.sumcon.sec_nis;
        this.sumcon = response.sumcon;

        this.multifamiliar = response.multifamiliar;
        this.meses_adeudados = response.recibos;
        this.param_cuota = response.param_cuota;
        this.responsable = response.responsable;

        this.dataSource = new MatTableDataSource<any>(this.meses_adeudados);
        this.dataSource.paginator = this.paginator;

        if (this.meses_adeudados && this.meses_adeudados.length > 0){
          let item = this.meses_adeudados[0];
          this.meses_seleccionados_map.set(item.simbolo_var, item);
          this.update_importe_financiar();
        }

        if (this.tamn_old != "")
          this.form.controls["tamn"].setValue(this.tamn_old + "%");
      });
  }

  initForm() {
    this.form = new FormGroup({
      cuota_inicial: new FormControl(0, [Validators.required]),
      cuotas: new FormControl(0, [Validators.required]),
      tamn: new FormControl({ value: this.tamn_old, disabled: true }, [
        Validators.required,
      ]),
    });
  }

  get_format_date(date: string, format: string = "MMMM YYYY") {
    return moment(date).format(format);
  }

  get_format_number(value: number) {
    if (value === null || value === undefined) {
      return "0";
    }
     return value.toLocaleString("en-us", { minimumFractionDigits: 2 });
     //return parseFloat(value1).toFixed(2).toString();
  }
  get_format_number_v1(value: number) {
    if (value === null || value === undefined) {
      return "0";
    }
     //return value.toLocaleString("en-us", { minimumFractionDigits: 2 });
     return value.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
  }
  get_total_importe() {
    let returned: number = 0;

    this.cronograma_cuotas.forEach((item: any) => {
      returned += parseFloat(item.imp_tot_cuota);
    });

    return this.get_format_number_v1(returned);
  }

  get_total_incentivo() {
    let returned: number = 0;

    this.cronograma_cuotas.forEach((item: any) => {
      returned += parseFloat(item.cc_ahorro);
    });

    return this.get_format_number_v1(returned);
  }

  mes_changed(event: any, item: any) {
    this.resetValues();
    if (event.checked) {
      if (!this.meses_seleccionados_map.has(item.simbolo_var)) {
          this.meses_seleccionados_map.set(item.simbolo_var, item);
      }
    } else {
      //if (this.meses_seleccionados_map.has(item.simbolo_var)) {
      //else
        this.meses_seleccionados_map.delete(item.simbolo_var);
      }
    this.update_importe_financiar();
  }

  mes_clicked(event: any, item: any) {
    let puede_marcar = true;
    let index = this.meses_adeudados.findIndex(x => x.simbolo_var == item.simbolo_var);
    if (!this.meses_seleccionados_map.has(item.simbolo_var)) {
        if (index > 0){
          let item_ant = this.meses_adeudados[index-1];
          if (!this.meses_seleccionados_map.has(item_ant.simbolo_var))
            puede_marcar = false;
        }
      }
      else {
        if (index >= 0 && index < this.meses_adeudados.length-1){
          let item_post = this.meses_adeudados[index+1];
          if (this.meses_seleccionados_map.has(item_post.simbolo_var))
            puede_marcar = false;

        }
      }
    if (!puede_marcar){
      event.preventDefault();
    }
  }

  resetValues() {
    this.form.reset();

    this.cronogramas_visible = false;
    this.cronograma_cuotas = [];

    //this.form.controls["tamn"].setValue(this.tamn_old + "%");
  }

  update_importe_financiar() {
    this.importe_financiar = 0;
    this.meses_seleccionados_map.forEach((value: any) => {
      this.importe_financiar += value.deuda;
    });

    this.importe_financiar = parseFloat(this.importe_financiar.toFixed(2));

    // this.importe_financiar = 499.99;
    console.log("this.importe_financiar: ",  Math.trunc(this.importe_financiar));
    this.esMontoFueraRango = true;
    this.monto_menor = 9999999;
    if (this.param_cuota.length > 0)
      this.monto_menor = this.param_cuota[0].rango_min;
    if (this.param_cuota)
    this.param_cuota.forEach((cuota: any) => {

      console.log("cuota.rango_min: ", cuota.rango_min);
      console.log("cuota.rango_max: ", cuota.rango_max);
      if (
        Math.trunc(this.importe_financiar) >= cuota.rango_min &&
        Math.trunc(this.importe_financiar) <= cuota.rango_max
      ) {
        this.setValidatorCuotaInicial(cuota);
        this.esMontoFueraRango = false;
      }
      if (this.monto_menor > cuota.rango_min)
        this.monto_menor = cuota.rango_min;
    });
    if (this.esMontoFueraRango && this.param_cuota.length > 0)
      this.setValidatorCuotaInicial(this.param_cuota[0]);
    if (this.esMontoFueraRango && this.importe_financiar > this.monto_menor)
      this.esMontoFueraRango = false;
  }

  setValidatorCuotaInicial(cuota: any) {
    const min_cuota_ini = parseFloat(
      ((this.importe_financiar * cuota.min_cuota_ini) / 100).toFixed(2)
    );
    this.cuota_min = min_cuota_ini;
    this.cuota_inicial_save = this.cuota_min;
    console.log("cuota.min_cuota_ini: ", cuota.min_cuota_ini);
    console.log("this.cuota_min: ", this.cuota_min);
    this.cuota_max = this.importe_financiar;
    this.form.controls["cuota_inicial"].setValue(min_cuota_ini);
    this.form.controls["cuota_inicial"].setValidators([
      Validators.required,
      Validators.min(min_cuota_ini),
      Validators.max(this.cuota_max),
    ]);
    this.form.controls["cuota_inicial"].updateValueAndValidity();

    this.num_cuotas = [];
    for (let index = 1; index <= cuota.cant_cuota; index++) {
      this.num_cuotas.push(index);
    }
    this.form.controls["cuotas"].setValue(cuota.cant_cuota);
  }

  select_all_changed(event: any) {
    this.resetValues();

    if (event.checked) {
      this.meses_adeudados.forEach((item: any) => {
        this.meses_seleccionados_map.set(item.simbolo_var, item);
      });
    } else {
      this.meses_seleccionados_map.clear();
    }

    this.update_importe_financiar();
  }

  get_checked(id: number) {
    return this.meses_seleccionados_map.has(id);
  }

  validar_si_es_fuera_rango()
  {
    if (this.esMontoFueraRango){
      this.toastr.warning(
        //`Deudas menores a S/ ${this.monto_menor}. Comuniquese con Aquafono`,
        "El importe a financiar es menor al permitido para el uso de esta aplicación, comuníquese con nuestro Aquafono al 317-8000 donde le brindaremos mayor información para su financiamiento",
        "Advertencia",
        {
          closeButton: true,
        }
      );
      return false;
    }
    return true;
  }

  calcular(el: any) {

    this.blockUI.update;
    this.blockUI.start();
     ;

    if (!this.validar_si_es_fuera_rango())
      return;

    if (this.meses_seleccionados_map.size <= 0) {
      this.toastr.warning(
        "Debe seleccionar al menos un mes adeudado",
        "Advertencia",
        {
          closeButton: true,
        }
      );
      return;
    }

    if (this.form.valid) {
     this.calcular_request(el);
    } else {
      let cuota_inicial : number;
      cuota_inicial = this.form.getRawValue().cuota_inicial.replace(",","").replace(",","");
      if (
        cuota_inicial < this.cuota_min ||
        cuota_inicial > this.importe_financiar
      ) {
        this.toastr.warning(
          "El monto de la cuota inicial no puede ser menor al monto sugerido, o mayor al Importe a Financiar",
          "Advertencia",
          {
            closeButton: true,
          }
        );
      }
      else {
        this.calcular_request(el);
      }
    }
  }

  calcular_request(el: any) {
    let formValues: any = this.form.getRawValue();
    let recibos: any[] = [];
    this.meses_seleccionados_map.forEach((value: any) => {
      recibos.push(value);
    });

    let request: any = {
      cant_cuotas: parseInt(formValues.cuotas),
      f_acu: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
      tasa_int: formValues.tamn,
      cuota_ini: formValues.cuota_inicial,
      tip_acu: "IP002", //constante
      multifamiliar: this.multifamiliar, //valor de consulta
      nis_rad: this.nro_sumininstro,
      sec_nis: this.sec_nis, //
      ind_mult_rec: true, //constante
      dni: this.nro_documento,
      tip_doc: this.tip_doc,
      recibos: recibos,
    };
    console.log("calcularCuotas REQUEST : ", request);
    this.financiamientoService
      .calcularCuotas(request)
      .toPromise()
      .then((response: any) => {
        console.log("calcularCuotas RESPONSE : ", response);
        if (response.error == true) {
            if (response.tipo == 'v') {
              this.toastr.error(response.msgerror, "Error", {
                closeButton: true,});
            }
          else {
              this.toastr.error("No se ha podido calcular las cuotas para el financiamiento. Inténtelo nuevamente.", "Error", {
                closeButton: true,});
          }
          return;
        }
        console.log("formValues.cuota_inicial.toString() ",formValues.cuota_inicial.toString().replace(",","").replace(",",""));
        this.form.controls["tamn"].setValue(response.tasa_int + "%");
        this.tamn_old = response.tasa_int;
        this.calc.ind_fact_online = response.ind_fact_online;
        this.calc.tasa_int = response.tasa_int;
        this.calc.imp_multas = response.imp_multas;
        this.calc.imp_recargos = response.imp_recargos;

        this.cronograma_cuotas = response.cuotas;
        this.dataSourceCronograma = new MatTableDataSource<any>(
          this.cronograma_cuotas
        );

        this.cronogramas_visible = true;
        this.scrollToBottom();

        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          setTimeout(() => {
            window.scrollBy(0, -100);
          }, 1000);
        }, 250);
      });
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop =
        this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

  enviar() {
    let bandFinalizado: boolean = true;
    if (!this.declaro) {
      this.toastr.warning(
        "Debe aceptar el consentimiento indicado",
        "Advertencia",
        {
          closeButton: true,
        }
      );

      return;
    }

    if (!this.validar_si_es_fuera_rango())
      return;

    let formValues: any = this.form.getRawValue();

    let recibos: any[] = [];
    this.meses_seleccionados_map.forEach((value: any) => {
      recibos.push(value);
    });

    //Validar si puede registrar en la base de datos
    let request_validarActualizarDatos: any = {
      bandejaId: -100,
    };


    console.log("validarActualizarDatos REQUEST: ",request_validarActualizarDatos);
    this.financiamientoService
    .validarActualizarDatosFinancimiento(request_validarActualizarDatos)
    .toPromise()
    .then((response_validarActualizarDatos: any) => {
      console.log("validarActualizarDatos RESPONSE : ", response_validarActualizarDatos);
      if (response_validarActualizarDatos.estado === 'ERROR') {
          this.toastr.error("No se ha podido generar el convenio. Inténtelo nuevamente.", "Error", {
            closeButton: true,});
            bandFinalizado = false;
            return;
      }

        //Validar si el file server funciona
        let request_validarFileServer: any = {
          idSuministro: this.nro_sumininstro,
        };
        console.log("validarFileServer REQUEST: ",request_validarFileServer);
        this.financiamientoService
        .validarFileServerFinancimiento(request_validarFileServer)
        .toPromise()
        .then((response_validarFileServer: any) => {
          console.log("validarFileServer RESPONSE : ", response_validarFileServer);
            if (response_validarFileServer.estado === 'ERROR') {
                this.toastr.error("No se ha podido generar el convenio. Inténtelo nuevamente.", "Error", {
                  closeButton: true,});
                  bandFinalizado = false;
                  return;
            }

            let correo_request = {
              usuario: this.nombres + " " + this.apellidos,
              emailTo: [this.emailSolicitante], //emailTo":[this.mail],
              emailCC: [],
              model: {
                f_vcto_cuota: this.cronograma_cuotas[0].f_vcto_cuota,
                imp_am_cuota: this.cronograma_cuotas[0].imp_am_cuota,
              },
            };
            console.log("API Correo financiamientoRealizado REQUEST : ",correo_request);
            this.financiamientoService
              .financiamientoRealizado(correo_request)
              .toPromise()
              .then((result: any) => {
                  console.log(
                    "API Correo financiamientoRealizado RESPONSE : ",
                    result
                  );
                  if (result.estado == "ERROR") {
                    this.toastr.error("No se pudo realizar el envío de la notificación por correo", "Error", {
                      closeButton: true,
                    });
                    return;
                  }

                        let request: any = {
                          cant_cuotas: parseInt(formValues.cuotas),
                          f_acu: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
                          tasa_int: formValues.tamn,
                          cuota_ini: formValues.cuota_inicial,
                          tip_acu: "IP002", //constante
                          multifamiliar: this.multifamiliar, //valor de consulta
                          nis_rad: this.nro_sumininstro,
                          sec_nis: this.sec_nis, //
                          ind_mult_rec: true, //constante
                          dni: this.nro_documento,
                          tip_doc: this.tip_doc,
                          calc: this.calc,
                          recibos: recibos,
                          cuotas: this.cronograma_cuotas,
                        };

                        console.log("API grabarCuotas RESPONSE : ", request);

                        this.financiamientoService
                        .grabarCuotas(request)
                        .toPromise()
                        .then((response: any) => {
                          //let response = this.grabarcuota_response;
                          console.log("grabarCuotas RESPONSE : ", response);
                          if (response.error == true) {
                            if (response.tipo == 'v') {
                              this.toastr.error(response.msgerror, "Error", {
                                closeButton: true,});
                            }
                          else {
                              this.toastr.error("No se ha podido generar el convenio. Inténtelo nuevamente.", "Error", {
                                closeButton: true,});
                          }
                            return;
                          }
                            this.recibos_pdf = response.recibos_pdf;
                            this.recibos_pdf1 = response.recibos_pdf1;
                            this.recibos_pdf2 = response.recibos_pdf2;
                            this.secuencial = response.secuencial;
                            this.num_acu = response.num_acu;
                            console.log("num_acu : ", this.num_acu);
                            /*        this.cronograma_cuotas = response.cuotas;
                                    this.dataSourceCronograma = new MatTableDataSource<any>(
                                      this.cronograma_cuotas
                                    ); */



                            let pdf_request = {
                              multifamiliar: this.multifamiliar,
                              nis_rad: this.nro_sumininstro,
                              sumcon: this.sumcon,
                              recibos1: this.recibos_pdf1,
                              recibos2: this.recibos_pdf2,
                              ind_fact_online: this.calc.ind_fact_online,
                              tasa_int: this.calc.tasa_int,
                              imp_multas: this.calc.imp_multas,
                              imp_recargos: this.calc.imp_recargos,
                              cuotas: this.cronograma_cuotas,
                              num_acu: response.num_acu,
                              secuencial: response.secuencial,
                              responsable: this.responsable,
                            };
                            console.log("API PDF descargarConvenio REQUEST : ", pdf_request);

                            let consultaDatos_request = {
                              bandejaId: this.bandejaId, //De datos-solicitante.component.ts
                              numeroAcuerdo: this.num_acu, //num_acu de API GRABAR
                              suministro: this.nro_sumininstro, //De datos-solicitante.component.ts
                              secuenciaSuministro: this.sumcon.sec_nis, //sumcon.sec_nis de API consulta
                              codigoOficina: this.sumcon.cod_unicom, //sumcon.cod_unicom de API consulta
                              tipoSolicitante:
                                this.tipoSolicitante == ""
                                  ? this.sumcon.tip_sol
                                  : this.tipoSolicitante, //Si tiene valor en datos-solicitante.component.ts se asigna sino el de sumcon.tip_sol de API consulta
                              paterno: this.sumcon.ape1, //sumcon.ape1 de API consulta
                              materno: this.sumcon.ape2, //sumcon.ape2 de API consulta
                              nombres: this.sumcon.nombre, //sumcon.nombres de API consulta
                              tipoDocumento: this.sumcon.tip_doc, //sumcon.tip_doc de API consulta
                              numDocumento: this.sumcon.doc_id, //sumcon.doc_id de API consulta
                              telefono: this.telefono, //De datos-solicitante.component.ts,
                              celular: this.celular, //De datos-solicitante.component.ts,
                              correo: this.emailSolicitante, //De datos-solicitante.component.ts,
                              nombreArchivo:
                                this.nro_sumininstro +
                                "_" +
                                this.sumcon.sec_nis +
                                "_" +
                                this.num_acu +
                                ".pdf",
                              deudaTotal: this.importe_financiar, //Monto Financiar de la web
                              numeroCuota: parseInt(formValues.cuotas), //Cantidad de cuotas de la web
                              montoCuota: formValues.cuota_inicial.toString().replace(",","").replace(",",""), //Cuota inicial a pagar de la web
                              numeroRecibo: recibos.length, //Cantidad Recibos seleccionados de la web
                              //documents: this.documents, //De datos-solicitante.component.ts
                              listArchivosAdjuntos: this.listArchivosAdjuntos, //De datos-solicitante.component.ts
                            };
                            console.log("API Consulta Datos REQUEST : ", consultaDatos_request);

                            this.financiamientoService
                              .actualizarDatosFinancimiento(consultaDatos_request)
                              .toPromise()
                              .then((result: any) => {
                                console.log("API Consulta Datos RESPONSE : ", result);
                                if (result.estado == "ERROR") {
                                  this.toastr.error(
                                    "Error no se pudo actualizar los datos del solicitante",
                                    "Error",
                                    {
                                      closeButton: true,
                                    }
                                  );
                                  return;
                                }
                              })
                              .catch((err) => { });

                            this.financiamientoService
                              .documentopdfRealizado(pdf_request)
                              .toPromise()
                              .then((result: any) => {
                                console.log("API PDF descargarConvenio RESPONSE : ", result);
                                if (result.error && result.error === true) {
                                  this.toastr.error(result.msgerror, "Error", {
                                    closeButton: true,
                                  });
                                  return;
                                }
                              })
                              .catch((err) => { });

                            this.finalizado = bandFinalizado;
                          });
                })
                .catch((error: any) => {
                  console.log("API Correo financiamientoRealizado ERROR ",error);
                  bandFinalizado = false;
                  return;
              });
          })
        .catch((error: any) => {
          console.log("validarFileServer ERROR ",error);
          bandFinalizado = false;
          return;
        });
    })
    .catch((error: any) => {
      console.log("validarActualizarDatosFinancimiento ERROR ",error);
      bandFinalizado = false;
      return;
    });



  }

  resetChanged(event: any) {
    if(this.tamn_old != "")
      this.form.controls["tamn"].setValue(this.tamn_old + "%");
  }

  onChangeCuota(value) {
        console.log("this.cuota_min ",this.cuota_min);
    if(value == "1") {
      this.form.controls["cuota_inicial"].setValue(this.importe_financiar.toFixed(2));
      this.form.controls["cuota_inicial"].disable();
    }
    else {
      this.form.controls["cuota_inicial"].setValue(this.cuota_inicial_save);
      this.form.controls["cuota_inicial"].enable();
    }
}

onFocusOutEvent(event: any){
  let len : number = 0;
  let value = event.target.value;

/*   console.log("value ", value);
  console.log("parseFloat(value) ", parseFloat(value)); */
  len = value.toString().length;
  if(len < 3 && parseFloat(value) >  0) {
    value = parseFloat(value).toFixed(2);
    this.form.controls["cuota_inicial"].setValue(value);
    (document.getElementsByName("cuota_inicial")[0] as HTMLInputElement).setSelectionRange(1,1);
  }
  this.cuota_inicial_save = value;
}
  validarCuotaInicial() {
    let value = this.form.getRawValue().cuota_inicial.toString();
    let cuotainicial : number = 0;
    let len : number = 0;

    value = value.replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, '$1.$2')
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        this.form.controls["cuota_inicial"].setValue(value);
        this.cuota_inicial_save = value;
/*     (document.getElementsByName("cuota_inicial")[0] as HTMLInputElement).value =
      value; */
  }

  aceptar() {
    this.meses_seleccionados_map.clear();
    this.finalizado = false;
    this.resetValues();
    //this.loadMesesAdeudados();
    this.router.navigate(["/consulta-tramite"]);
  }
}
